module.exports = __webpack_public_path__ + "static/media/ocp-logo.c6dead63.svg";